import {
  Checkbox,
  ListItem,
  ListItemButton,
  ListItemText,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import InputControl from "../../../shared/components/InputControl";

export const PlAndBsListFilterSection = ({
  state,
  storeList,
  financialYearList,
  accountMonthList,
  handleChangeFilter,
  hideMonthQuarters = false,
  validator = null,
}) => {
  const renderTags = () => <></>;
  const getOptionLabel = (option) => option.label;
  const isOptionEqualToValue = (option, value) => option.value === value.value;

  const isFinancialYearMultiple = Array.isArray(
    state.filter.values.financialYear
  );

  const helperText = validator
    ? {
        store: validator.current.message(
          "Store",
          state.filter.values.store,
          "required"
        ),
        financialYear: validator.current.message(
          "Financial year",
          state.filter.values.financialYear,
          "required"
        ),
        month: validator.current.message(
          "Month",
          state.filter.values.month,
          "required"
        ),
      }
    : {};

  return (
    <React.Fragment>
      {storeList && (
        <InputControl
          type="dropdown"
          name="store"
          label="Store"
          multiple={true}
          disableCloseOnSelect
          disableClearable={true}
          getOptionLabel={getOptionLabel}
          isOptionEqualToValue={isOptionEqualToValue}
          options={state.filter.options.stores}
          value={state.filter.values.store}
          onChange={(_, value) => handleChangeFilter({ name: "store", value })}
          renderTags={renderTags}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Store"
              placeholder="Store"
              error={Boolean(helperText?.store)}
              helperText={helperText?.store}
            />
          )}
          groupBy={(option) => option.franchisee_name}
          renderGroup={(params) => {
            const { values, options } = state.filter;

            const isAllChecked = values.store.length === options.stores.length;

            const fullOptions = options.stores.filter(
              (store) => store.franchisee_name === params.group
            );

            const selectedOptions = values.store.filter(
              (store) => store.franchisee_name === params.group
            );

            const isChecked = fullOptions.length === selectedOptions.length;

            const handleHeaderClick = ({ item }) => {
              if (item === "all") {
                handleChangeFilter({
                  event: null,
                  name: "store",
                  value: isAllChecked ? [] : options.stores,
                });
              } else {
                handleChangeFilter({
                  event: null,
                  name: "store",
                  value: isChecked
                    ? values.store.filter(
                        (store) =>
                          !selectedOptions.find(
                            (opt) =>
                              opt.franchisee_name === store.franchisee_name
                          )
                      )
                    : values.store.concat(
                        fullOptions.filter(
                          (option) =>
                            !values.store.find(
                              (selectedStore) =>
                                selectedStore.value === option.value
                            )
                        )
                      ),
                });
              }
            };

            return (
              <React.Fragment key={params.group}>
                {params.key === 0 && (
                  <ListItemButton
                    disableGutters
                    onClick={() => handleHeaderClick({ item: "all" })}
                    selected={isAllChecked}
                  >
                    <Checkbox size="small" checked={isAllChecked} />
                    <Typography>All</Typography>
                  </ListItemButton>
                )}
                {params.group && (
                  <ListItemButton
                    disableGutters
                    onClick={() => handleHeaderClick({ item: params.group })}
                    selected={isChecked}
                  >
                    <Checkbox size="small" checked={isChecked} />
                    <Typography fontWeight={500}>{params.group}</Typography>
                  </ListItemButton>
                )}
                <ListItemText>{params.children}</ListItemText>
              </React.Fragment>
            );
          }}
          renderOption={(props, option, { selected }) => (
            <ListItem
              {...props}
              key={option.value}
              disableGutters
              disablePadding
            >
              <Checkbox
                style={{ marginRight: 8 }}
                checked={selected}
                size="small"
              />
              {option.label}
            </ListItem>
          )}
          // sx={{ width: 250 }}
        />
      )}
      {accountMonthList && (
        <InputControl
          type="dropdown"
          name="month"
          label="Month"
          multiple={true}
          disableCloseOnSelect
          disableClearable={true}
          getOptionLabel={getOptionLabel}
          isOptionEqualToValue={isOptionEqualToValue}
          options={state.filter.options.accountMonths}
          value={state.filter.values.month}
          onChange={(_, value) => handleChangeFilter({ name: "month", value })}
          renderTags={renderTags}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Month"
              placeholder="Month"
              error={Boolean(helperText?.month)}
              helperText={helperText?.month}
            />
          )}
          renderOption={(props, option, { selected }) => (
            <ListItem
              {...props}
              key={option.value}
              disableGutters
              disablePadding
            >
              <Checkbox
                style={{ marginRight: 8 }}
                checked={selected}
                size="small"
              />
              {option.label}
            </ListItem>
          )}
          groupBy={() => "Yearly"}
          renderGroup={(params) => {
            const { values, options } = state.filter;
            const checkedStatus = {
              all: values.month.length === options.accountMonths.length,
              Q1:
                values.month.filter((month) => month.quarter === "Q1")
                  .length === 3,
              Q2:
                values.month.filter((month) => month.quarter === "Q2")
                  .length === 3,
              Q3:
                values.month.filter((month) => month.quarter === "Q3")
                  .length === 3,
              Q4:
                values.month.filter((month) => month.quarter === "Q4")
                  .length === 3,
            };

            const handleHeaderClick = ({ item }) => {
              if (item === "all") {
                handleChangeFilter({
                  event: null,
                  name: "month",
                  value: checkedStatus[item] ? [] : options.accountMonths,
                });
              } else {
                handleChangeFilter({
                  event: null,
                  name: "month",
                  value: checkedStatus[item]
                    ? values.month.filter((month) => month.quarter !== item)
                    : values.month.concat(
                        options.accountMonths.filter(
                          (month) =>
                            month.quarter === item &&
                            !values.month.find(
                              (selectedMonth) =>
                                selectedMonth.value === month.value
                            )
                        )
                      ),
                });
              }
            };
            return (
              <React.Fragment key={params.group}>
                <ListItemButton
                  onClick={() => handleHeaderClick({ item: "all" })}
                  selected={checkedStatus.all}
                >
                  <Checkbox size="small" checked={checkedStatus.all} />
                  <Typography>{params.group}</Typography>
                </ListItemButton>
                {!hideMonthQuarters &&
                  [
                    { label: "Quarter 1 (Jul - Sep)", value: "Q1" },
                    { label: "Quarter 2 (Oct - Dec)", value: "Q2" },
                    { label: "Quarter 3 (Jan - Mar)", value: "Q3" },
                    { label: "Quarter 4 (Apr - Jun)", value: "Q4" },
                  ].map((item, index) => (
                    <ListItemButton
                      key={index}
                      onClick={() => handleHeaderClick({ item: item.value })}
                      selected={checkedStatus[item.value]}
                    >
                      <Checkbox
                        size="small"
                        checked={checkedStatus[item.value]}
                      />
                      <Typography>{item.label}</Typography>
                    </ListItemButton>
                  ))}
                <ListItemText>{params.children}</ListItemText>
              </React.Fragment>
            );
          }}
          // sx={{ maxWidth: "fit-content", minWidth: 250 }}
        />
      )}
      {financialYearList && (
        <InputControl
          type="dropdown"
          name="financialYear"
          label="Financial Year"
          multiple={isFinancialYearMultiple}
          disableCloseOnSelect
          disableClearable={isFinancialYearMultiple}
          getOptionLabel={getOptionLabel}
          isOptionEqualToValue={isOptionEqualToValue}
          options={state.filter.options.financialYears}
          value={state.filter.values.financialYear}
          onChange={(_, value) =>
            handleChangeFilter({ name: "financialYear", value })
          }
          groupBy={isFinancialYearMultiple ? () => "All" : undefined}
          renderGroup={
            isFinancialYearMultiple
              ? (params) => {
                  const { values, options } = state.filter;
                  const isChecked =
                    values.financialYear.length ===
                    options.financialYears.length; //isAllChildChecked({ params });

                  const handleHeaderClick = () => {
                    handleChangeFilter({
                      event: null,
                      name: "financialYear",
                      value: isChecked ? [] : options.financialYears,
                    });
                  };
                  return (
                    <React.Fragment key={params.group}>
                      <ListItemButton
                        onClick={handleHeaderClick}
                        sx={{
                          flexDirection: "row",
                          alignItems: "center",
                          ":hover": {
                            cursor: "pointer",
                            backgroundColor: "rgba(0,0,0,0.04)",
                          },
                        }}
                      >
                        <Checkbox size="small" checked={isChecked} />
                        <Typography>{params.group}</Typography>
                      </ListItemButton>
                      <ListItemText>{params.children}</ListItemText>
                    </React.Fragment>
                  );
                }
              : undefined
          }
          renderTags={renderTags}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Financial Year"
              placeholder="Financial year"
              error={Boolean(helperText?.financialYear)}
              helperText={helperText?.financialYear}
            />
          )}
          renderOption={
            isFinancialYearMultiple
              ? (props, option, { selected }) => (
                  <ListItem
                    {...props}
                    key={option.value}
                    disableGutters
                    disablePadding
                  >
                    <Checkbox
                      style={{ marginRight: 8 }}
                      checked={selected}
                      size="small"
                    />
                    {option.label}
                  </ListItem>
                )
              : undefined
          }
          // sx={{ maxWidth: "fit-content", minWidth: 250 }}
        />
      )}
    </React.Fragment>
  );
};
